/**
 * Map the qualitative statements to point values.
 */
export enum Symptoms {
  NONE = 1,
  LIGHT,
  MEDIUM,
  STRONG,
  VERY_STRONG
}
